import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import RelatorioPedido from '../app/Components/RelatorioPedido/RelatorioPedido';
import { useAuth } from '../app/Context/auth'; // Usar nosso hook


function RelatorioPedidoPage() {
    const { id } = useParams();
    const { currentUser } = useAuth(); // Usar currentUser para pegar o token
    
    // Estado simplificado
    const [dadosRelatorio, setDadosRelatorio] = useState(null);
    const [carregando, setCarregando] = useState(true);
    const [erro, setErro] = useState('');

    useEffect(() => {
        if (!id || !currentUser) {
            setCarregando(false);
            setErro('ID do pedido ou usuário não disponível.');
            return;
        }

        const fetchData = async () => {
            setCarregando(true);
            setErro('');
            try {
                const token = await currentUser.getIdToken();
                const API_URL = process.env.REACT_APP_API_URL;
                const response = await fetch(`${API_URL}/api/pedidos/${id}/relatorio`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });

                if (!response.ok) {
                    const errorData = await response.json();
                    throw new Error(errorData.error || "Falha ao carregar dados do relatório.");
                }
                
                const data = await response.json();
                setDadosRelatorio(data);

            } catch (error) {
                console.error("ERRO CRÍTICO ao buscar dados para o relatório:", error);
                setErro(error.message);
                setDadosRelatorio(null);
            } finally {
                setCarregando(false);
            }
        };

        fetchData();
    }, [id, currentUser]);

    if (carregando) {
        return <div className="loading-fullscreen">Preparando relatório...</div>;
    }
    
    if (erro || !dadosRelatorio) {
        return <div className="p-4 text-center text-danger font-weight-bold">ERRO: {erro || 'Não foi possível carregar os dados do pedido.'}</div>;
    }

    // Passa os dados de forma mais estruturada para o componente filho
    const relatorioProps = {
        pedido: {
            numero: dadosRelatorio.numero,
            dataCadastro: dadosRelatorio.data_cadastro,
            acrescimos: dadosRelatorio.acrescimos,
            frete: dadosRelatorio.frete
        },
        cliente: {
            nome: dadosRelatorio.cliente_nome,
            rua: dadosRelatorio.cliente_rua,
            numero: dadosRelatorio.cliente_numero,
            bairro: dadosRelatorio.cliente_bairro,
            cidade: dadosRelatorio.cliente_cidade,
            uf: dadosRelatorio.cliente_uf,
            telefone: dadosRelatorio.cliente_telefone
        },
        tenant: {
            nome: dadosRelatorio.tenant_nome
        },
        itens: dadosRelatorio.itens || [], // Passa os itens já buscados
        financeiro: dadosRelatorio.financeiro || [] // Passa o financeiro já buscado
    };


    return (
        <div className="relatorio-print-page">
            <style>{`@media print {.no-print {display: none !important;}}`}</style>
            
            <div className="actions-bar no-print">{/* ... (seus botões) ... */}</div>
            
            <div id="relatorio-a-ser-impresso">
                {/* Passa as props desestruturadas */}
                <RelatorioPedido {...relatorioProps} /> 
            </div>
        </div>
    );
}

export default RelatorioPedidoPage;